import { createSelector } from "@ngrx/store";
import { BackendConfiguration } from "src/app/models/backend_configuration";
import { AppState } from "../state/app.state";


const getBackendConfiguration = (state: AppState) => state.backendConfiguration;

export const selectBackendConfiguration = createSelector(
  getBackendConfiguration,
  (config : BackendConfiguration) => config);